export const SET_MOBILE = 'SET_MOBILE';
export const SET_COMPONENT = 'SET_COMPONENT';
export const LOCATION_CHANGE = 'LOCATION_CHANGE';
